import { createFileRoute } from '@tanstack/react-router';

import Dashboard from '~/app/praetors/dashboard/Dashboard';

export const Route = createFileRoute('/_app/home/praetors/$praetorId/')({
	beforeLoad: () => ({
		getTitle: undefined
	}),
	component: function PraetorDashboard() {
		const { praetorId } = Route.useParams();
		return <Dashboard praetorId={praetorId} />;
	}
});
